/*---------------------------------------------------------------------------
 The following JavaScript functions control Tender wizard client side functions
-----------------------------------------------------------------------------*/

// Functions for the login page
var TECL_TenderAccountLogin = {

  // Display the please wait dialog
  AuthenticateUserDetails: function(e) {

    if (e.preventDefault) {
      e.preventDefault();
    } else {
      // In case browser does not support "preventDefault"
      e.returnValue = false;
    }

    var emailAddress = $("#UserEmailAddress").val();
    var password = $("#UserPassword").val();

    if (emailAddress && password) {
      $("#errUserDetails").addClass("hidden");

      if (TECL_Master.AddLock("TECL_TenderAccountLoginAuthenticateUserDetails")) {
        var returnUrl = TECL_Master.GetParameterByName("returnUrl") || "";
        $.ajax({
          url: baseSiteUrl + "umbraco/Surface/TenderAccountSurface/AuthenticateUser",
          type: "POST",
          dataType: "json",
          data: {
            emailAddress: emailAddress,
            password: password,
            returnUrl: returnUrl
          },
          error: function(exc) {
            TECL_Master.ClearLock("TECL_TenderAccountLoginAuthenticateUserDetails");
            $("#errUserDetails").removeClass("hidden");
          },
          success: function(redirectUrl) {
            TECL_Master.ClearLock("TECL_TenderAccountLoginAuthenticateUserDetails");

            if (redirectUrl) {
              window.location = redirectUrl;
            } else {
              $("#errUserDetails").removeClass("hidden");
            }
          }
        });
      }
    } else {
      $("#errUserDetails").removeClass("hidden");
    }
  },

  // Check a login
  LoginCheck: function() {
    var webAccountId = $("#ddlSupplierLogins").val();

    if (webAccountId) {
      if (TECL_Master.AddLock("TECL_TenderAccountLoginAdminLogin")) {
        $.ajax({
          url: baseSiteUrl + "umbraco/Surface/TenderAccountSurface/LoginCheck",
          type: "POST",
          dataType: "json",
          data: {
            webAccountId: webAccountId
          },
          error: function(exc) {
            TECL_Master.ClearLock("TECL_TenderAccountLoginAdminLogin");
          },
          success: function(redirectUrl) {
            TECL_Master.ClearLock("TECL_TenderAccountLoginAdminLogin");
            if (redirectUrl) {
              window.location = redirectUrl;
            }
          }
        });
      }
    }
  },

  // Display forgotten password dialog
  ForgottenPassword: function() {
    // Reset the dialog
    $("#forgottenPasswordEmailAddress").val("");
    $("#forgottenPasswordEmailAddressErr").addClass("hidden");

    // Display the dialog
    $("#forgottenPasswordDlg")
      .modal({
        backdrop: "static",
        keyboard: false
      });
    $("#forgottenPasswordDlg").modal("show");
  },

  // Validate and sent reset email
  ValidateAndSentResetEmail: function() {
    $("#forgottenPasswordEmailAddressErr").addClass("hidden");
    var emailAddress = $("#forgottenPasswordEmailAddress").val();
   
    if (emailAddress && emailAddress.length > 0) {
      if (TECL_TenderGeneral.IsEmailValid(emailAddress)) {
        if (TECL_Master.AddLock("TECL_TenderAccountLoginForgottenPassword")) {
          $.ajax({
            url: baseSiteUrl + "umbraco/Surface/TenderAccountSurface/ValidateAndSentResetEmail",
            type: "POST",
            dataType: "json",
            data: {
              emailAddress: emailAddress
            },
            error: function(exc) {
              TECL_Master.ClearLock("TECL_TenderAccountLoginForgottenPassword");
            },
            success: function(result) {
              TECL_Master.ClearLock("TECL_TenderAccountLoginForgottenPassword");
              if (result) {
                if (result.EmailSent) {
                  $("#forgottenPasswordDlg").modal("hide");
                  $("#forgottenPasswordEmailSentDlg").modal("show");
                } else {
                  $("#forgottenPasswordEmailAddressErr").empty().html(result.ErrorMessage);
                  $("#forgottenPasswordEmailAddressErr").removeClass("hidden");
                }
              } else {
                var emailValidationError = $("#forgottenPasswordEmailValidationError").val();
                $("#forgottenPasswordEmailAddressErr").empty().html(emailValidationError);
                $("#forgottenPasswordEmailAddressErr").removeClass("hidden");
              }
            }
          });
        }
      } else {
        var emailFormatError = $("#forgottenPasswordEmailFormatError").val();
        $("#forgottenPasswordEmailAddressErr").empty().html(emailFormatError);
        $("#forgottenPasswordEmailAddressErr").removeClass("hidden");
      }
    } else {
      var missingAddressError = $("#forgottenPasswordMissingAddressError").val();
      $("#forgottenPasswordEmailAddressErr").empty().html(missingAddressError);
      $("#forgottenPasswordEmailAddressErr").removeClass("hidden");
    }
  },

  // Update the password
  ResetPassword: function() {

    // get password values
    var newPassword = $("#supplierPasswordChangeNewPassword").val();
    var confirmNewPassword = $("#supplierPasswordChangeConfirmNewPassword").val();
    var resetKey = $("#passwordResetKey").val();

    if (TECL_TenderAccountLogin.ValidatePasswordResetInfo(newPassword, confirmNewPassword)) {
      if (TECL_Master.AddLock("TECL_TenderAccountLoginResetPassword")) {
        $.ajax({
          url: baseSiteUrl + "umbraco/Surface/TenderAccountSurface/ResetPassword",
          type: "POST",
          dataType: "json",
          data: {
            resetKey: resetKey,
            newPassword: newPassword
          },
          error: function(exc) {
            TECL_Master.ClearLock("TECL_TenderAccountLoginResetPassword");
            TECL_Master.ShowErrorDialog();
          },
          success: function(result) {
            TECL_Master.ClearLock("TECL_TenderAccountLoginResetPassword");
            if (result) {
              $("#changePasswordDataSection").addClass("hidden");
              $("#passwordChangedSection").removeClass("hidden");

              TECL_TenderGeneral.DisplayMessageDlg("Password changed");
            } else {
              TECL_Master.ShowErrorDialog("Failed to change your password.");
            }
          }
        });
      }
    }
  },

  // validate the password reset info is correct
  ValidatePasswordResetInfo: function(newPassword, confirmNewPassword) {
    var isValid = true;

    $("#supplierPasswordChangeNewPasswordErr").addClass("hidden");
    $("#supplierPasswordChangeConfirmNewPasswordErr").addClass("hidden");

    if (!newPassword || newPassword.length < 5) {
      $("#supplierPasswordChangeNewPasswordErr").removeClass("hidden");
      isValid = false;
    } else if (!confirmNewPassword || newPassword !== confirmNewPassword) {
      $("#supplierPasswordChangeConfirmNewPasswordErr").removeClass("hidden");
      isValid = false;
    }
    return isValid;
  }
};

// Functions for the account change details page
var TECL_TenderAccountDetails = {

  // Initialise the account details page
  Initialise: function() {

    $('#accountDetailTabs a').click(function(e) {
      e.preventDefault();
      $(this).tab("show");
    });

    TECL_Master.StopKendoDropDownScrollBug();

    // Added change event to checkboxes
    $("[name='checkboxSelector']").change(function() {
      TECL_TenderGeneral.ChangedCheckboxLabelClass($(this));
    });

    // Update the classes for all checkbox labels
    $("[name='checkboxSelector']").each(function() {
      TECL_TenderGeneral.ChangedCheckboxLabelClass($(this));
    });

  },

  // Move a available product group to selected
  AvailableSelectedProductMove: function(productGroupId) {
    $("#availableProductGroups").find("[name=" + productGroupId + "]").addClass("hidden");
    $("#selectedProductGroups").find("[name=" + productGroupId + "]").removeClass("hidden");
  },

  // Move a selected product group to available
  SelectedProductMove: function(productGroupId) {
    $("#availableProductGroups").find("[name=" + productGroupId + "]").removeClass("hidden");
    $("#selectedProductGroups").find("[name=" + productGroupId + "]").addClass("hidden");
  },

  // Save the product group changes
  ProductCategoryChanged: function(e) {
    var currentCategoryId = $("#selectedCategoryId").val();
    var newCategoryId = e.dataItem.Value;
    var productGroupsIds = TECL_TenderAccountDetails.GetSelectedProducts();

    if (TECL_Master.AddLock("ProductCategoryChanged")) {
      $.ajax({
        url: baseSiteUrl + "umbraco/Surface/TenderAccountSurface/ProductCategoryChanged",
        type: "POST",
        data: {
          currentCategoryId: currentCategoryId,
          productGroupsIds: productGroupsIds,
          newCategoryId: newCategoryId
        },
        error: function(exc) {
          TECL_Master.ClearLock("ProductCategoryChanged");
          TECL_Master.ShowErrorDialog();
        },
        success: function(result) {
          TECL_Master.ClearLock("ProductCategoryChanged");
          if (result) {
            $("#productGroupSeletor").empty().html(result);
          } else {
            TECL_Master.ShowErrorDialog("Failed to update your product groups");
          }
        }
      });
    }
  },

  // Get the selected products
  GetSelectedProducts: function() {
    var productGroupsIds = [];

    $("#selectedProductGroups").find("li").each(function() {
      if (!$(this).hasClass("hidden")) {
        var productGroupId = $(this).attr("name");

        if (productGroupId) {
          productGroupsIds.push(productGroupId);
        }
      }
    });

    return productGroupsIds;
  },

  // Save the product group changes
  SaveProductGroupChanges: function() {

    var productGroupIds = [];
    $("#tenderSupplierProductGroupsTab").find("[name=checkboxSelector]").each(function() {
      var checkbox = $(this);

      if (checkbox.is(":checked")) {
        productGroupIds.push(checkbox.val());
      }
    });

    if (TECL_Master.AddLock("SaveProductGroupChanges")) {
      $.ajax({
        url: baseSiteUrl + "umbraco/Surface/TenderAccountSurface/SaveProductGroupChanges",
        type: "POST",
        dataType: "json",
        data: {
          productGroupIds: productGroupIds
        },
        error: function(exc) {
          TECL_Master.ClearLock("SaveProductGroupChanges");
          TECL_Master.ShowErrorDialog();
        },
        success: function(result) {
          TECL_Master.ClearLock("SaveProductGroupChanges");
          if (result) {
            TECL_TenderGeneral.DisplayMessageDlg("Product groups updated");
          } else {
            TECL_Master.ShowErrorDialog("Failed to update you product groups");
          }
        }
      });
    }
  },

  // Save the location changes
  SaveLocationChanges: function() {
    var tokens = [];

    $("#tenderSupplierLocationTab").find("[name=checkboxSelector]").each(function() {
      var checkbox = $(this);

      if (checkbox.is(":checked")) {
        tokens.push(checkbox.val());
      }
    });

    if (TECL_Master.AddLock("SaveLocationChanges")) {
      $.ajax({
        url: baseSiteUrl + "umbraco/Surface/TenderAccountSurface/SaveLocationChanges",
        type: "POST",
        dataType: "json",
        data: {
          tokens: tokens
        },
        error: function(exc) {
          TECL_Master.ClearLock("SaveLocationChanges");
          TECL_Master.ShowErrorDialog();
        },
        success: function(result) {
          TECL_Master.ClearLock("SaveLocationChanges");
          if (result) {
            TECL_TenderGeneral.DisplayMessageDlg("Locations updated");
          } else {
            TECL_Master.ShowErrorDialog("Failed to update you locations");
          }
        }
      });
    }
  },

  // Save the account details changes
  SaveAccountDetail: function() {

    var isNew = $("#supplierDetailsIsNew").val() === "True" || $("#supplierDetailsIsNew").val() === "true";
    var firstName = $("#supplierDetailsFirstName").val();
    var lastName = $("#supplierDetailsLastName").val();
    var jobTitle = $("#supplierDetailsJobTitle").val();
    var phoneNumber = $("#supplierDetailsPhoneNumber").val();
    var emailAddress = $("#supplierDetailsEmailAddress").val();
    var confirmEmailAddress = $("#supplierDetailsConfirmEmailAddress").val();
    var organisationId = $("#supplierDetailsOrganisationId").val();
    var password = null;
    var confirmPassword = null;
    var tAndCAccepted = false;

    if (isNew) {
      password = $("#supplierDetailsPassword").val();
      confirmPassword = $("#supplierDetailsConfirmPassword").val();
      tAndCAccepted = $("#acceptTandCs").is(":checked");
    }

    if (TECL_TenderAccountDetails.ValidateAccountDetail(firstName, lastName, jobTitle, emailAddress, confirmEmailAddress, password, confirmPassword, isNew, tAndCAccepted)) {
      if (TECL_Master.AddLock("ChangeDetailsSaveAccountDetail")) {
        $.ajax({
          url: baseSiteUrl + "umbraco/Surface/TenderAccountSurface/SaveUserDetails",
          type: "POST",
          dataType: "json",
          data: {
            firstName: firstName,
            lastName: lastName,
            jobTitle: jobTitle,
            phoneNumber: phoneNumber,
            emailAddress: emailAddress,
            isNew: isNew,
            password: password,
            organisationId: organisationId
          },
          error: function(exc) {
            TECL_Master.ClearLock("ChangeDetailsSaveAccountDetail");
            TECL_Master.ShowErrorDialog();
          },
          success: function(result) {
            TECL_Master.ClearLock("ChangeDetailsSaveAccountDetail");
            if (result && result.Saved) {

              $("#messageDisplayDlgMessage").empty().html("Changes saved");
              $("#messageDisplayDlg").modal("show");

              function HideItemAddedDlg() {
                $("#messageDisplayDlg").modal("hide");

                var redirectUrl = $("#successRedirectUrl").val();
                if (redirectUrl) {
                  window.location.href = redirectUrl;
                }
              }

              // Wait a set amount of time till the dialog is closed
              setTimeout(HideItemAddedDlg, 2000);

            } else {
              if (result && result.ErrorMessage) {
                TECL_Master.ShowErrorDialog(result.ErrorMessage);
              } else {
                TECL_Master.ShowErrorDialog("Failed to validate your existing password");
              }
            }
          }
        });
      }
    }

  },

  // validate the account details
  ValidateAccountDetail: function(firstName, lastName, jobTitle, emailAddress, confirmEmailAddress, password, confirmPassword, isNew, tAndCAccepted) {
    var isValid = true;

    $("#supplierDetailsFirstNameErr").addClass("hidden");
    $("#supplierDetailsLastNameErr").addClass("hidden");
    $("#supplierDetailsJobTitleErr").addClass("hidden");
    $("#supplierDetailsEmailAddressErr").addClass("hidden");
    $("#supplierDetailsConfirmEmailAddressErr").addClass("hidden");
    $("#supplierDetailsPasswordErr").addClass("hidden");
    $("#supplierDetailsConfirmPasswordErr").addClass("hidden");
    $("#acceptTandCsErr").addClass("hidden");

    if (!firstName) {
      $("#supplierDetailsFirstNameErr").removeClass("hidden");
      isValid = false;
    }

    if (!lastName) {
      $("#supplierDetailsLastNameErr").removeClass("hidden");
      isValid = false;
    }

    if (!jobTitle) {
      $("#supplierDetailsJobTitleErr").removeClass("hidden");
      isValid = false;
    }

    if (!emailAddress || !TECL_TenderGeneral.IsEmailValid(emailAddress)) {
      $("#supplierDetailsEmailAddressErr").removeClass("hidden");
      isValid = false;
    } else if (!confirmEmailAddress || emailAddress !== confirmEmailAddress) {
      $("#supplierDetailsConfirmEmailAddressErr").removeClass("hidden");
      isValid = false;
    }

    if (isNew) {
      if (!password || password.length < 5) {
        $("#supplierDetailsPasswordErr").removeClass("hidden");
        isValid = false;
      } else if (!confirmPassword || password !== confirmPassword) {
        $("#supplierDetailsConfirmPasswordErr").removeClass("hidden");
        isValid = false;
      }

      if (!tAndCAccepted) {
        $("#acceptTandCsErr").removeClass("hidden");
        isValid = false;
      }
    }
    return isValid;
  },

  // Update the users password
  UpdatePassword: function() {
    // get password values
    var oldPassword = $("#supplierPasswordChangeExistingPassword").val();
    var newPassword = $("#supplierPasswordChangeNewPassword").val();
    var confirmNewPassword = $("#supplierPasswordChangeConfirmNewPassword").val();

    if (TECL_TenderAccountDetails.ValidatePasswordChangePassword(oldPassword, newPassword, confirmNewPassword)) {
      if (TECL_Master.AddLock("ChangePasswordUpdatePassword")) {
        $.ajax({
          url: baseSiteUrl + "umbraco/Surface/TenderAccountSurface/UpdatePassword",
          type: "POST",
          dataType: "json",
          data: {
            oldPassword: oldPassword,
            newPassword: newPassword
          },
          error: function(exc) {
            TECL_Master.ClearLock("ChangePasswordUpdatePassword");
            TECL_Master.ShowErrorDialog();
          },
          success: function(result) {
            TECL_Master.ClearLock("ChangePasswordUpdatePassword");
            if (result) {
              TECL_TenderGeneral.DisplayMessageDlg("Password updated");
            } else {
              TECL_Master.ShowErrorDialog("Failed to validate your existing password.");
            }
          }
        });
      }
    }
  },

  // validate the password change
  ValidatePasswordChangePassword: function(oldPassword, newPassword, confirmNewPassword) {
    var isValid = true;

    $("#supplierPasswordChangeExistingPasswordErr").addClass("hidden");
    $("#supplierPasswordChangeNewPasswordErr").addClass("hidden");
    $("#supplierPasswordChangeConfirmNewPasswordErr").addClass("hidden");

    if (!oldPassword) {
      $("#supplierPasswordChangeExistingPasswordErr").removeClass("hidden");
      isValid = false;
    }

    if (!newPassword || newPassword.length < 5) {
      $("#supplierPasswordChangeNewPasswordErr").removeClass("hidden");
      isValid = false;
    } else if (!confirmNewPassword || newPassword !== confirmNewPassword) {
      $("#supplierPasswordChangeConfirmNewPasswordErr").removeClass("hidden");
      isValid = false;
    }
    return isValid;
  }
};

// Functions for the account change details page
var TECL_TenderNewAccountDetails = {

  // Display the account details if the key is valid
  DisplayDetails: function() {
    var supplierKey = $("#supplierOrganisationId").val();
    $("#ErrorText").addClass("hidden");
    $("#newAccountDetails").addClass("hidden");

    if (supplierKey) {
      if (TECL_Master.AddLock("TECL_TenderNewAccountDetailsValidateOrgId")) {
        $.ajax({
          url: baseSiteUrl + "umbraco/Surface/TenderAccountSurface/ValidateOrgId",
          type: "POST",
          dataType: "json",
          data: {
            supplierKey: supplierKey
          },
          error: function(exc) {
            TECL_Master.ClearLock("TECL_TenderNewAccountDetailsValidateOrgId");
            TECL_Master.ShowErrorDialog();
          },
          success: function(errorText) {
            TECL_Master.ClearLock("TECL_TenderNewAccountDetailsValidateOrgId");
            if (errorText) {
              $("#ErrorText").removeClass("hidden");
              $("#ErrorText").empty().html(errorText);
            } else {
              TECL_TenderNewAccountDetails.DisplayNewAccountDetails(supplierKey);
            }
          }
        });
      }
    } else {
      $("#ErrorText").removeClass("hidden");
      $("#ErrorText").empty().html("Missing supplier key");
    }
  },

  // Display the details view
  DisplayNewAccountDetails: function(orgId) {
    if (TECL_Master.AddLock("TECL_TenderNewAccountDetailsDisplayNewAccountDetails")) {
      $.ajax({
        url: baseSiteUrl + "umbraco/Surface/TenderAccountSurface/GetNewAccountDetails",
        type: "POST",
        data: {
          orgId: orgId
        },
        error: function(exc) {
          TECL_Master.ClearLock("TECL_TenderNewAccountDetailsDisplayNewAccountDetails");
          TECL_Master.ShowErrorDialog();
        },
        success: function(viewResult) {
          TECL_Master.ClearLock("TECL_TenderNewAccountDetailsDisplayNewAccountDetails");
          if (viewResult) {
            $("#newAccountDetails").removeClass("hidden");
            $("#newAccountDetails").empty().html(viewResult);
          } else {
            TECL_Master.ShowErrorDialog();
          }
        }
      });
    }
  },

  // Display the t&c dialog
  DisplayTermsAndConditions: function() {
    $("#termsAndConditionsDlg").modal("show");
  },

  // The user select the I agree button on the T&C dialog
  AgreeTermsAndConditions: function() {
    $("#acceptTandCs").prop('checked', true);
    $("#termsAndConditionsDlg").modal("hide");
  }

};
